<template>
  <section class="main_wrap">
    <!--工具条-->
    <el-col :span="24" class="toolbar search-bar" style="padding-bottom: 0px;">
        <el-input v-model="keyword" placeholder="请输入bus_app_id" @keyup.enter.native="getUsers"></el-input>
         <el-input v-model="bus_trading_id" placeholder="请输入bus_trading_id"></el-input>
        <el-button type="primary" @click="getUsers">查询</el-button>
    </el-col>

    <!--列表-->
    <el-table :data="contracts" highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.bus_app_id }}</span>
        </template>
      </el-table-column>

     <el-table-column label="bus_trading_id" width="">
        <template slot-scope="scope">
          <span>{{scope.row.bus_trading_id}}</span>
        </template>
      </el-table-column>

      <el-table-column label="时间" width="">
        <template slot-scope="scope">
          <span>{{scope.row.created_at | formatDate}}</span>
        </template>
      </el-table-column>

      <el-table-column label="详情" width="">
        <template slot-scope="scope">
         <p v-on:click="isSee()"><a href="#">查看数据</a></p>
        </template>
      </el-table-column>
    </el-table>
    <div class="Change" v-show="See" >
      <el-table :data="contracts"  highlight-current-row v-loading="listLoading" style="width: 100%;">
       <el-table-column
        label="ID"
        width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.appId }}</span>
        </template>
       </el-table-column>

      <el-table-column label="offerDesc" width="">
        <template slot-scope="scope">
          <span>{{scope.row.datas.offerDesc}}</span>
        </template>
      </el-table-column>

      <el-table-column label="offerResult" width="">
        <template slot-scope="scope">
        <span>{{scope.row.datas.offerResult}}</span>
        </template>
      </el-table-column>

      <el-table-column label="payCompany" min-width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.payCompany }}</span>
        </template>
      </el-table-column>

      <el-table-column label="swiftNo" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.swiftNo }}</span>
        </template>
      </el-table-column>
      <el-table-column label="thirdRetCode" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.thirdRetCode }}</span>
        </template>
      </el-table-column>
      <el-table-column label="transSwiftNo" width="">
        <template slot-scope="scope">
          <span>{{ scope.row.datas.transSwiftNo }}</span>
        </template>
      </el-table-column>
     </el-table>
    </div>
    <!-- 弹层 -->
     <div class="masklayer" id="mask" v-show="mask" style="height: 995px;">
      <span class="cross" v-on:click="cross()">关闭</span>
    </div>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <span class="total_number" style="margin-top: 7px;display: inline-block;"> 共计 <span v-model="total_count"> {{total_count}} </span> 条 </span>
      <el-pagination
        v-show="pagination"
        style="float:right;"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="prev, pager, next, jumper"
        :total="total_count">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
    import { BusTradingResult } from '../../api/api';
    import { formatDate } from '../../utils/utils.js';
    export default {
      // created() {
      //   this.listLoading = true;
      //   //get list
      //   BusTradingResult()
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },
      // beforeRouteUpdate(to, from, next) {
      //   this.listLoading = true;
      //   //get list
      //   BusTradingResult(to.query)
      //     .then((res) => {
      //       if(res.status === 0){
      //         this.contracts = res.data.data;
      //         this.total_count = res.data.total_count;
      //         this.listLoading = false;
      //         if(res.data.total_pages < 2){
      //           this.pagination = false;
      //         }
      //       }
      //     })
      // },
      // 时间转换
      filters: {
        formatDate(time) {
            return formatDate(time, 'yyyy-MM-dd hh:mm');
        }
      },
      data() {
        return {
          keyword: '',
          bus_trading_id:'',
          mask:false,
          See:false,
          //===有分页会用到
          currentPage: 1,
          listLoading: false,
          total_count: 0,
          pagination: true,
          //=====
           contracts: [],
           dataContent:[]

        }
      },
      methods: {
        getUsers() {
          let params = {
            'bus_app_id': this.keyword,
            'bus_trading_id': this.bus_trading_id,
             //'page':      this.currentPage
          };
          BusTradingResult(params).then((res) => {
            if(res.status === 0){
              this.contracts = res.data.trading_results
              //console.log( this.contracts )
              this.total_count =res.data.trading_results.length;
              // if(res.data.total_pages < 2){
              //   this.pagination = false;
              // }else {
              //   this.pagination = true;
              // }
            }
          })
        },
        handleCurrentChange(val) {
          this.currentPage = val;
          this.getUsers();
        },
        isSee:function(){
          this.mask =! this.mask;
         this.See =! this.See;
        },
         cross:function(){
           this.mask = false;
           this.See =false;
        }
      }
    }

</script>

<style lang="scss">
  @import "../../assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// src/views/tableList/BusTradingResult.vue